import React, { Component }  from 'react';
import Menu from '../../Menu/Menu.js';

class CV extends Component {
    render() {
      return (
        <Menu Title="Curr&iacute;culum" MenuId="Curriculum"> 
          <h2>Antonio Fern&aacute;ndez-Abascal Alonso</h2>
            <ul className="CVList">
                <li>Diplomado en Fisioterapia por la Universidad de Gimbernat-Cantabria</li> 
                <li>Master Oficial en Terapia Manual por la Universidad Europea de Madrid (UEM)</li> 
                <li>Master en Técnicas Osteopáticas del Aparato Locomotor por la Escuela de Osteopatía de Madrid (EOM)</li> 
                <li>Nivel 4 en Osteopatía por la Escuela de Osteopatía de Madrid (EOM)</li> 
                <li>Curso Síndrome del Dolor Miofascial: Tratamiento Conservador y Punción Seca de los puntos gatillos Miofasciales</li> 
                <li>Biomec&aacute;nica avanzada del pie y la marcha. Reevolution Athletics.</li> 
                <li>Functional Movement Screen (FMS) Nivel 1</li> 
                <li>Certificado ACSAS Foundations</li> 
                <li>Human performance Specialist nivel 1 (Movement Matters)</li> 
                <li>Curso Reeducación Postural Método K-Stretch</li> 
                <li>Curso La Fisioterapia en el Deporte </li> 
                <li>Curso Fisioterapia Visceral: La importancia de la nutrición en la patología osteomuscular</li> 
                <li>Curso Salud musculoesqueletica y dolor crónico por el Instituto de Ciencias de Nutrición y Salud (ICNS)</li> 
                <li>Curso Nutrición Clinica Avanzada Nivel 1 por el Instituto de Ciencias de Nutrición y Salud (ICNS)</li> 
                <li>Curso Nutrición Clinica Avanzada Nivel 2 por el Instituto de Ciencias de Nutrición y Salud (ICNS)</li> 
                <li>Congreso Nutrición Celular Activa: "La inflamación silenciosa"</li> 
                <li>Congreso Nutrici&oacute;n Celular Activa: "Abordaje terap&eacute;utico en el s&iacute;ndrome de f&aacute;tiga cr&oacute;nica"</li> 
                <li>Curso Tratamiento Orofacial y Trastornos del lenguaje</li> 
                <li>Colegio Fisioterapeutas de Cantabria Nº 39/554</li> 
            </ul>
            <h2>Tamara Garc&iacute;a Lera </h2>
            <ul className="CVList">
                <li>Diplomada en Fisioterapia por la Uax - Madrid</li> 
                <li>Master con Nivel estructural, craneal, visceral en Osteopat&iacute;a, escuela ICOMED</li> 
                <li>Diplomada por la escuela de perfeccionamiento Biom&eacute;dica,en kinesiolog&iacute;a aplicada</li> 
                <li>T&eacute;cnico Superior en Diet&eacute;tica y Nutrici&oacute;n</li> 
                <li>Experto en Fisioterapia Obst&eacute;trica, terapia manual Pelviperineal y uroginecolog&iacute;ca. Impartido por el CRF Amostegui y Cpfcyl</li> 
                <li>Tratamiento del C&oacute;lico del Lactante</li> 
                <li>Terapia manual en la esfera cr&aacute;neo-mand&iacute;bular</li> 
                <li>S&iacute;ndrome del Dolor Miofascial: Tratamiento Conservador, Punci&oacute;n Seca de los puntos gatillos Miofasciales</li> 
                <li>Experto en Inducci&oacute;n Miofascial</li> 
                <li>Curso Reeducaci&oacute;n Postural Gimnasia Abdominal Hipopresiva – 5p – Pilates Mat</li> 
                <li>Jornadas Abordaje Multidisciplinar de los trastornos del equilibrio - sistema vestibular</li> 
                <li>Colegio Fisioterapeutas de Cantabria Nº 39/742</li> 
            </ul>
            <h2>Marta Bolado Noriega</h2>
            <ul className="CVList">
              <li>Graduada en fisioterapia en la Universidad Pontificia de Comillas</li> 
              <li>Master en fisioterapia deportiva y readaptación de lesiones (U. Gimbernat)</li> 
              <li>Master en osteopatía estructural del aparato locomotor (Escuela Osteopatia de Madrid)</li> 
              <li>Experta en Pilates suelo, máquinas y aéreo (AEFEP)</li> 
              <li>Master-Experta en Gimnasia Abdominal Hipopresiva (Marcel Caufriez)</li> 
              <li>Fisioterapia conservadora e invasiva (punción seca) de puntos gatillo miofasciales (Travell y Simons)</li> 
              <li>Tratamiento integral del sistema fascial (ITNM)</li> 
              <li>Valoración y tratamiento de ATM: Disfunciones temporo-mandibulares</li> 
              <li>Análisis biomecánico y tratamiento integral del triatleta</li> 
              <li>Análisis Biomecánico de la marcha y carrera a pie (I-Biomecanics)</li> 
              <li>Atención integral al corredor (I-Biomecanics)</li> 
              <li>Colegio Fisioterapeutas de Cantabria Nº 39/638</li>
            </ul>
        </Menu>
      );
    }
  }

export default CV;


// WEBPACK FOOTER //
// ./src/Components/Sections/CV/CV.js